/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Ivan Ryabov
 */
import React, { Component } from 'react'

import ColorPicker from '../../../components/ColorPicker'
import Autocomplete from '../../../components/Autocomplete'
import { TRCInput } from '../../../trace'

import './EditGameTeam.css'

/*
 * Props
 *
 * homeTeamId
 * awayTeamId
 * homeScore
 * homeScoreChanged
 * awayScore
 * awayScoreChanged
 * homeColor
 * homeColorChanged
 * awayColor
 * awayColorChanged
 * homeEditable
 * homeTeamTitle
 * homeTeamTitleChanged
 * awayTeamTitle
 * awayTeamTitleChanged
 * suggestions
 * homeSuggestions
 * suggestionPressed
 * homeSuggestionPressed
 */

export default class EditGameTeam extends Component {

    constructor(props) {
        super(props)

        this.colors = [
            '#ffffff',
            '#9e9e9e',
            '#000000',
            '#3f51b5',
            '#673ab7',
            '#9c27b0',
            '#e91e63',
            '#f44336',
            '#ff9800',
            '#ffc107',
            '#ffeb3b',
            '#cddc39',
            '#8bc34a',
            '#4caf50',
            '#009688',
            '#00bcd4',
            '#03a9f4',
            '#2196f3',
            '#795548'
        ]
        this.scores = Array(21).fill(0).map((v,i) =>i)
    }

    renderTeamSuggestions() {
        var items = this.props.suggestions.map((team) => { 
            return (
                <li key={team.title}>
                    <a href="#team" onClick={this.props.suggestionsPressed}>
                        {team.title}
                    </a>
                </li>
            )
        })

        if (this.props.suggestions.length) {
            return (
                <ul className="team-suggestions">
                    {items}
                </ul>
            )
        } else {
            return null
        }
    }

    render() {
        var styles = {}
        if (this.props.show === false) {
            styles = { display: 'none' }
        }



        return (
            <div style={styles} className="EditGameTeam trc-grid">
                <div className="col m-ff12 ml-f5">
                    <p className="home-team-score">
                        <TRCInput
                            type="select"
                            name="home_team_score"
                            onChange={ this.props.homeScoreChanged }
                            value={ this.props.homeScore }
                            options={ this.scores }
                        />
                    </p>
                    <p className="home-team-color">
                        <ColorPicker 
                            colors={this.colors} 
                            value={this.props.homeColor}
                            onChange={this.props.homeColorChanged} />
                    </p>
                    <p className="home-team-name">
                        <input
                            type="number"
                            name="home_team_id"
                            disabled
                            hidden
                            value={this.props.homeTeamId} />
                        { ! this.props.homeEditable && (
                            <TRCInput
                                disabled
                                value={this.props.homeTeamTitle}
                            />
                        )}
                        { this.props.homeEditable && (
                            <Autocomplete
                                name="home_team_title"
                                placeholder="Home Team Name"
                                suggestions={this.props.homeSuggestions}
                                onChange={this.props.homeTeamTitleChanged}
                                value={this.props.homeTeamTitle}
                                suggestionsPressed={this.props.homeSuggestionsPressed} />
                        )}
                    </p>
                </div>

                <p className="col m-ff12 ml-f1 vs">vs.</p>

                <div className="trc-grid col m-ff12 ml-f5">
                    <p className="away-team-score">
                        <TRCInput
                            type="select"
                            name="away_team_score"
                            onChange={ this.props.awayScoreChanged }
                            value={ this.props.awayScore }
                            options={ this.scores }
                        />
                    </p>
                    <p className="away-team-color">
                        <ColorPicker 
                            colors={this.colors} 
                            value={this.props.awayColor}
                            onChange={this.props.awayColorChanged} />
                    </p>
                    <p className="away-team-name">
                        <input
                            type="number"
                            name="away_team_id"
                            disabled
                            hidden
                            value={this.props.awayTeamId} />
                        <Autocomplete
                            name="away_team_title"
                            placeholder="Opponent Team Name"
                            suggestions={this.props.suggestions}
                            onChange={this.props.awayTeamTitleChanged}
                            value={this.props.awayTeamTitle}
                            suggestionsPressed={this.props.suggestionsPressed} />
                    </p>
                </div>

            </div>
        )
    }

}
